import React, { Component, useEffect } from "react";
import {
  Keyboard,
  ScrollView,
  Dimensions,
  Vibration,
  StatusBar,
} from "react-native";
import * as Animatable from "react-native-animatable";
import { connect, useDispatch, useSelector } from "react-redux";
import { changeActionState } from "@microdoing/shared/services/action/actions";
import {
  cancelAllNotifications,
  scheduleGoalNotif,
} from "@microdoing/shared/services/notifService";
import { getUserFirstName } from "@microdoing/shared/services/user/selectors";
import {
  Box,
  MainButton,
  MainText,
  MainTitle,
  MySafeAreaView,
} from "../../components/common";
import LottieAchieve from "./LottieAchieve";
import i18n from "@microdoing/shared/i18n";
import ResultBox from "./ResultBox";
import { getTeamProgress } from "@microdoing/shared/services/team/selectors";
import { getCampaignUserProgress } from "@microdoing/shared/services/action/selectors";
import {
  getUserCampaignStrategy,
  getUserCampaignStreak,
  getUserCampaignTeamSize,
} from "@microdoing/shared/services/userCampaign/selectors";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";
import theme from "app/Theme/Theme";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import WebDesktopView from "app/components/common/Web/WebDesktopView";
import { breadCrumbsReflexiveAnalysisResult } from "app/navigation/breadcrumb/BreadcrumbPaths";
import { pluralizeI18n } from "app/utils/plurialize";

const WIDTH = isWebDesktop ? 400 : "100%";

const ResultScreen = ({ navigation }) => {
  const currentStreak = useSelector(getUserCampaignStreak);
  const teamProgress = useSelector(getTeamProgress);
  const userProgress = useSelector(getCampaignUserProgress);
  const firstName = useSelector(getUserFirstName);
  const teamSize = useSelector(getUserCampaignTeamSize);
  const strategy = useSelector(getUserCampaignStrategy);

  const dispatch = useDispatch();

  useEffect(() => {
    Keyboard.dismiss();
    dispatch(changeActionState({ actionState: "neutral" }));
    Keyboard.dismiss();
    Vibration.vibrate(400);
  }, []);

  const onPressContinue = async () => {
    if (strategy === "bestFit") {
      navigation.replace("NextAction");
    } else {
      await cancelAllNotifications();
      await scheduleGoalNotif();
      // First action done
      navigation.replace("Main");
    }
  };

  return (
    <WebDesktopView breadcrumbsPath={breadCrumbsReflexiveAnalysisResult}>
      <MySafeAreaView flex={1}>
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "flex-start",
            backgroundColor: isWebDesktop
              ? "transparent"
              : theme.colors["neutral.75"],
          }}
          testID="next-action-screen"
          style={{ with: "100%" }}
        >
          <StatusBar backgroundColor={theme.colors["neutral.75"]} />
          <Box
            alignItems="center"
            width={WIDTH}
            paddingHorizontal="m"
            flex={1}
            style={{ marginTop: -theme.spacing.sm }}
          >
            <LottieAchieve />
            <Box
              flex={1}
              width={WIDTH}
              justifyContent={isWeb ? "flex-start" : "flex-start"}
            >
              <Animatable.View useNativeDriver animation="fadeInUp" delay={400}>
                <MainTitle variant="l6-bold" textAlign="center" marginTop="s">
                  {i18n.t("challenge-done", { firstName })}
                </MainTitle>
                <MainText
                  marginBottom={isWeb ? "xl" : "sl"}
                  marginTop="xs"
                  textAlign="center"
                  variant="l4-medium"
                  color="neutral.500"
                >
                  {i18n.t("challenge-done-subtitle")}
                </MainText>
              </Animatable.View>
              <ResultBox
                delay={700}
                color={theme.colors["system.red.900"]}
                iconName="streak"
                name={i18n.t("result-streak-name")}
                legend={i18n.t("result-streak-legend")}
                gain={currentStreak}
                width
              />
              <ResultBox
                delay={900}
                color={theme.colors["system.orange.900"]}
                iconName="action"
                name={pluralizeI18n("result-action-name", userProgress)}
                legend={i18n.t("result-action-legend")}
                gain={userProgress}
              />
              {teamSize > 1 && (
                <ResultBox
                  delay={1200}
                  color={theme.colors["system.green.900"]}
                  iconName="team"
                  name={pluralizeI18n("result-team-name", teamProgress)}
                  legend={i18n.t("result-team-legend")}
                  gain={teamProgress}
                />
              )}
            </Box>
            <Box
              width={isWeb ? "100%" : "auto"}
              marginBottom={isWeb ? "sm" : "null"}
            >
              <MainButton
                marginBottom="m"
                onPress={onPressContinue}
                text={i18n.t("continue")}
                testID="result-screen-next-button"
              />
            </Box>
          </Box>
        </ScrollView>
      </MySafeAreaView>
    </WebDesktopView>
  );
};

export default ResultScreen;
